import { CheckCircleIcon } from "@phosphor-icons/react/CheckCircle";
import { ClipboardTextIcon } from "@phosphor-icons/react/ClipboardText";
import { EmptyState } from "@freightsimple/ui-core/Display/EmptyState";
import { Page } from "@freightsimple/ui-core/PageLayout/Page";
import { T } from "@freightsimple/ui-core/Typography/T";
import { carriersApi } from "@/App/Auth/carrierApi";
import { OperationalIssuesPanels } from "@/App/Tables/OperationalIssuesPanels";
import { CarrierLoadFailed } from "@/App/CarrierLoadFailed";
import { useCarrierFetch } from "@/App/useCarrierFetch";
import { CarrierPageLogo } from "@/App/CarrierPageLogo";

export function OperationalIssuesView() {
  const { state, refreshing, refresh } = useCarrierFetch(() =>
    carriersApi().getCarrierOperationalIssues(),
  );
  const issues = state.status === "loaded" ? state.data.issues : undefined;

  return (
    <Page
      leadingVisual={<CarrierPageLogo />}
      icon={ClipboardTextIcon}
      title="Operational Issues"
      description="Open items that need your attention on shipments with FreightSimple."
      headerStats={
        issues ? [{ label: "Open", value: issues.length }] : undefined
      }
      refreshing={refreshing}
    >
      {state.status === "loading" && (
        <T size="sm" color="secondary">
          Loading…
        </T>
      )}
      {state.status === "error" && (
        <CarrierLoadFailed what="your operational issues" onRetry={refresh} />
      )}
      {issues && issues.length === 0 && (
        /* Empty here is the good outcome, not a dead end — say so, rather than
           leaving a carrier wondering whether the page failed to load. */
        <EmptyState
          icon={CheckCircleIcon}
          title="You're all caught up"
          description="Nothing on your shipments with FreightSimple needs your attention right now. We'll email you if something does."
        />
      )}
      {issues && issues.length > 0 && (
        <OperationalIssuesPanels issues={issues} />
      )}
    </Page>
  );
}
